import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("g", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, [
      createElementVNode("path", { d: "M.75 12a11.25 11.25 0 1 0 22.5 0 11.25 11.25 0 1 0-22.5 0" }),
      createElementVNode("path", { d: "M14.72 8a1.64 1.64 0 0 0-1.13-.46A1.59 1.59 0 0 0 12 9.09v1.41L9.47 8a1.64 1.64 0 0 0-1.13-.5 1.59 1.59 0 0 0-1.59 1.59v5.82a1.59 1.59 0 0 0 1.59 1.59 1.6 1.6 0 0 0 1.13-.5L12 13.5v1.41a1.59 1.59 0 0 0 1.59 1.59 1.6 1.6 0 0 0 1.13-.5L18 12.71a1 1 0 0 0 0-1.42Z" })
    ], -1)
  ]));
}
const entertainmentControlButtonCircleRightArrowFastForward = { render };
export {
  entertainmentControlButtonCircleRightArrowFastForward as default,
  render
};
//# sourceMappingURL=entertainment-control-button-circle-right-arrow-fast-forward.svg.js.map
